(function() {
	'use strict';
	angular.module('app.core')
		.directive('leanNumerical', leanNumerical);
	
	leanNumerical.$inject = ['$translate'];
	function leanNumerical($translate) {
		var html = '<div class="numerical-menu" ng-show="$parent.filterFunctions.getViewValues().visibleMenu == ' + "'" + '{{filterId}}' + "'" + '" ng-click="$event.stopPropagation();">' +
						'<form name="numericalForm" novalidate>' +
							'<div class="numerical-header">' +
								'<div class="numerical-title"><span translate> {{filterName}}</span></div>' +
							'</div>' +
							'<div class="numerical-body">' +
								'<div class="filter-dropdown form-group" ng-click="$event.stopPropagation();">' +
									'<select name="comparator" ng-required="true" class="form-control" ng-model="filterComparator" ng-options="comp.name for comp in $parent.filterFunctions.comparators | filter:filterNotBetween() | filter:translateOption()" ng-disabled="readOnly">' +
									'</select>' +
									'<input name="valueOne" type="number" class="form-control" ng-required="true" ng-model="filterValueOne" placeholder="' + $translate.instant('Enter value') + '..." ng-disabled="readOnly">' +
									'<input name="valueTwo" type="number" class="form-control" ng-required="filterComparator.abbr === ' + "'btw'" + '" ng-model="filterValueTwo" ng-show="filterComparator.abbr === ' + "'btw'" + '" placeholder="' + $translate.instant('Enter value') + '..." ng-disabled="readOnly">' +
								'</div>' +
							'</div>' +
							'<div class="numerical-footer" ng-show="!readOnly">' +
								'<button type="button" class="button flat colored innerButton" ng-click="$parent.filterFunctions.cancelSelection()">' +
									'<span translate>Cancel</span>' +
								'</button>' +
								'<button type="submit" class="button flat colored innerButton" data-testid="reportFilter-' + '{{filterId}}' + '-apply-btn" ng-disabled="$parent.filterFunctions.isReadOnly() || numericalForm.comparator.$invalid || numericalForm.valueOne.$invalid || numericalForm.valueTwo.$invalid" ng-click="$parent.filterFunctions.applySelection($event, filterId)">' +
									'<span translate>Apply</span>' +
								'</button>' +
							'</div>' +
						'</form>' +
					'</div>';
		return {
			restrict:'EA',
			template: html,
			replace:true,
			transclude: true,
			scope: {filterName: '@',
											filterValueOne: '=',
											filterValueTwo: '=',
											filterComparator: '=',
											filterShowNotBtw: '=',
											filterLabel: '@',
											filterId: '@'},
			link: function(scope, element, attrs) {
				scope.readOnly = scope.$parent.filterFunctions.isReadOnly();
				scope.excludeNotBetweenOption = !scope.filterShowNotBtw;
				scope.getItemLabel = function(item) {
					return scope.$eval(scope.filterLabel, item);
				};
				scope.filterNotBetween = function() {
					if (scope.excludeNotBetweenOption) {
						return function( item ) {
							return item.name != 'Not Between';
						};
					} else {
						return function( item ) {
							return true;
						};
					}
				};

				scope.translateOption = function () {
					return function(item) {
						item.name = $translate.instant(item.name);
						return item;
					};
				};
			}
		};
	}
})();
